import styled from 'styled-components';
import { typography } from 'dab-component-lib';
import { MediaStyle, basic, GridRowStyle, GridColStyle } from '../../utils/style-utils';

export const BackStyle = styled.a`
  ${typography.Body1};
  font-weight: bold;
  color: ${basic.secondary};
  cursor: pointer;
`;

export const ListRowStyle = GridRowStyle.extend`
  flex-direction: column;
  display: block;
  ${ MediaStyle.md`
    display: flex;
    flex-direction: row;
    flew-wrap: nowrap;
    margin-top: 15px;
  ` }
`;

export const ListColStyle = GridColStyle.extend`
  ${props => props.quarter && `
    & > div {
      margin-bottom: 15px;
    }
  `}
  ${ MediaStyle.md`
    width: ${props => props.quarter ? 'calc(25% - 10px)' : 'auto'};
    margin: ${props => props.quarter ? '75px 15px 10px 5px' : '10px 5px 10px 15px'};
    flex: ${props => props.quarter && 'none'};
    flex-grow: ${props => !props.quarter && '1'};
    flex-shrink: ${props => !props.quarter && '1'};
    flex-basis:${props => !props.quarter && '0'}; 
  ` }
`;

export const FilterWrapperStyle = styled.div`
  & > div {
    margin-bottom: 15px;
  }
`;

export const CatalogueLink = styled.div`
  display: none;
  align-items: center;
  color: ${basic.secondary};
  cursor: pointer;
  padding: 15px 5px;
  ${typography.Body1}
  span {
    margin-left: 8px;
  }
  ${ MediaStyle.md`
    display: flex;
  ` }
  ${ MediaStyle.lg`
    ${typography.Subheader1}
  ` }
`;

export const OrderContainerStyle = styled.div`
  box-shadow: 0px 0px 3px 1px #999;
  padding: 30px;
`;

export const OrderHeaderStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
`;

export const OrderNameStyle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 0;
`;

export const OrderCodeStyle = styled.div`
  ${typography.Title1};
  color: ${basic.secondary};
  margin-right: 10px;
`;

export const CardContainer = styled.div`
  margin-bottom: 20px;
`;

export const OrderToolbarStyle = styled.div`
  padding: 30px 0;
`;

export const OrderFooterStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
`;

export const NotesStyle = styled.div`
  padding: 30px;
`;

export const NoteTitleStyle = styled.h3`
  ${typography.Title1};
  color: ${basic.secondary};
`;

export const NoteTextStyle = styled.p`
  ${typography.Body2};
`;


// WEBPACK FOOTER //
// ./src/components/oldOrderDetail/style.js